//文献菜单分类
export const PAGE_TYPE = {
  ALL: 0,
  RECENT: 1,
  UNCLASSIFIED: 2,
  RECYCLE: 3,
  NO_FILES: 5,
  MY_THEME: 4,
  SHARED_THEME: 6,
};
export const PAGE_TYPE_MAP = {
  ALL: "全部",
  RECENT: "最近添加",
  UNCLASSIFIED: "未分类",
  NO_FILES: "无文件",
  MY_THEME: "我的主题",
  SHARED_THEME: "共享主题",
};
